import { Container } from 'react-bootstrap';
import { ReactNode } from 'react';
import Header from '../Header';
import Footer from '../Footer';
import SkipLinks from '../Utilities/skipLinks';
import BackToTopButton from '../Utilities/backToTopButton';
import RouteAccessibleNavigation from '../Utilities/routeAccessibleNavigation';
import RouteChangeScrollTop from '../Utilities/routeChangeScrollTop';
import GoogleAnalytics from '../../analytics/GoogleAnalytics';

interface LayoutProps {
    children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => (
    <>
        <SkipLinks />
        <Header />
        <Container fluid id='main' role='main' className='px-0' tabIndex={-1}>
            <GoogleAnalytics
                anonymiseIp={false}
                testMode={false}
                sendPageView
            >
                {children}
            </GoogleAnalytics>
        </Container>
        <Footer />
        <BackToTopButton />
        <RouteAccessibleNavigation />
        <RouteChangeScrollTop />
    </>
);

export default Layout;
